import { User } from '@/models/user/user';
import gql from 'graphql-tag';
import { executeQuery } from '../client';

const CURRENT_USER_QUERY = gql`
  {
    me {
      sub
      family_name
      given_name
      name
      memberof {
        o
        cn
        ou
      }
    }
  }
`;

export async function getCurrentUser(): Promise<User> {
  const { me } = await executeQuery<{ me: User }>(CURRENT_USER_QUERY);

  return me;
}
